export default {
  home: {
    metaTitle: "USFans Spreadsheet – Creator Guide, Reviews & Resources",
    metaDescription: "Explore the USFans Spreadsheet with creator resources, reviews, shipping information, coupons, safety guides, comparisons and practical USFans tips.",
    hero: {
      badge: "Independent resource · Regularly updated",
      title: "USFans Spreadsheet — Your Complete USFans Resource Hub",
      subtitle: "Find better information with the USFans Spreadsheet. Explore USFans-related resources, creator details, reviews, shipping guides, coupons, warehouse information, safety tips and practical tutorials — all organized in one easy-to-use hub.",
      primaryCta: "Explore USFans Spreadsheet",
      secondaryCta: "Buy It Now",
      trust: "Independent resource · Easy-to-navigate guides · Updated regularly",
    },
    what: {
      title: "What Is the USFans Spreadsheet?",
      p1: "The USFans Spreadsheet is a structured resource designed to make USFans-related information easier to discover, compare and understand. Instead of searching through scattered pages, you can explore organized guides, creator resources, shipping details, reviews and safety recommendations in a single place.",
      p2: "Because the spreadsheet groups information by category, it helps you move from a broad search to a specific product or creator quickly — without jumping between dozens of unrelated pages.",
      cta: "Explore the Spreadsheet Hub",
    },
    features: {
      title: "Everything You Need to Know About USFans",
      subtitle: "A quick overview of the most useful topics around the USFans Spreadsheet.",
      spreadsheet: { title: "USFans Spreadsheet", desc: "Explore the central spreadsheet resource and related information." },
      review: { title: "USFans Review", desc: "Understand key features, advantages, limitations and user considerations." },
      shipping: { title: "USFans Shipping Cost", desc: "Learn what can affect shipping prices and how to compare options." },
      coupon: { title: "USFans Coupon", desc: "Find information about available promotions and how coupons work." },
      discount: { title: "USFans Discount Code", desc: "Learn how to verify discount information before using a code." },
      warehouse: { title: "USFans Warehouse", desc: "Understand warehouse, storage and fulfillment considerations." },
      legit: { title: "Is USFans Legit?", desc: "Learn how to evaluate legitimacy, trust, security and platform info." },
      safety: { title: "USFans Safety", desc: "Follow practical privacy, account and safe-browsing recommendations." },
    },
    popular: {
      title: "Start With the Complete Guide",
      subtitle: "Our in-depth guide explains what the USFans Spreadsheet is, why it matters and how to use it.",
      cta: "Read the Complete Guide",
    },
    faqSection: {
      title: "Frequently Asked Questions",
      items: [
        { q: "What is the USFans Spreadsheet?", a: "It is a structured resource that organizes USFans-related information — creators, categories, shipping and more — into one easy-to-browse hub." },
        { q: "Is the USFans Spreadsheet free to browse?", a: "Browsing organized guides and category information is free. Purchases happen on the main store." },
        { q: "How do I find a specific product?", a: "Use the category list on this page to jump directly to the relevant section of the main store." },
        { q: "Is USFans legit?", a: "Always verify information through official sources and review the store policies before purchasing." },
      ],
    },
    finalCta: {
      title: "Ready to Explore the Full Store?",
      subtitle: "Jump straight to the main website to browse every category and product.",
      primary: "Visit the Main Website",
      secondary: "Buy It Now",
    },
  },
};